import { Component, Input, forwardRef, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';

import dayjs from 'dayjs';

export interface RenderedFieldConfig {
	label: string;
	type: string;
	itype?: string;
	name?: string;
	step?: number;
	valueProp?: string;
	labelProp?: string;
	contenttype?: string;
	content?: any;
	dataSource?: any;
	extendable?: boolean;
	includeInStats?: boolean;
	priority?: string;
	public?: boolean;
	visible?: boolean;
	icon?: string;
}

@Component({
	selector: 'bb-field-renderer',
	templateUrl: './bb-field-renderer.component.html',
	styleUrls: ['./bb-field-renderer.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbFieldRendererComponent),
		multi: true
	}]
})

export class BbFieldRendererComponent implements ControlValueAccessor, OnInit {
	@Input() fieldConfig: RenderedFieldConfig = null;
	@Input() displayInline: boolean;
	@Input() theme: '' | 'dark';
	@Input() cssClass = '';
	@Output() change = new EventEmitter<any>();
	@Output() optionSelected = new EventEmitter<any>();
	modelValue: any;
	date: Date;
	dateString: string;

	// private subscriptions = new Subscription();

	formControl: UntypedFormControl;

	constructor() {
		this.formControl = new UntypedFormControl();
	}

	ngOnInit() { }

	get field() {
		return this.fieldConfig;
	}

	onDateChange(value: any) {
		if (value) {
			this.date = new Date(value);
			this.dateString = dayjs(value).format('YYYY-MM-DD');
			// writeValue should be ISOString
			this.propagateChange(this.date.toISOString());
		} else {
			this.date = null;
			this.dateString = '';
			this.propagateChange('');
		}
	}

	onFontOptionSelected(fontOption: any) {
		if (!fontOption) {
			return;
		}
		this.optionSelected.emit(fontOption);
	}

	onModelChange(value: any) {
		this.modelValue = value;
		this.propagateChange(value);
	}

	onMatToggleChange(checked: boolean) {
		if (this.fieldConfig.type === 'string') {
			this.modelValue = checked ? 'true' : 'false';
		} else {
			this.modelValue = checked;
		}
		this.propagateChange(this.modelValue);
	}

	onChange(value: any) {
		this.change.emit(value);
	}

	// ControlValueAccessor fields:
	writeValue(value: any) {
		if (this.fieldConfig.itype === 'date') {
			// writeValue should be ISOString
			if (value) {
				this.dateString = dayjs(value).format('YYYY-MM-DD');
			} else {
				this.date = null;
				this.dateString = '';
			}

		} else {
			this.modelValue = value;
		}

	}

	propagateChange = (_: any) => { };

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() { }
}
